import React from 'react';
import { Button } from 'components/shadcn/ui/button';
import { useNavigate } from 'react-router-dom';
import { useGetIDsFromURL } from 'components/DeviceDetails/helper';

export const ViewLogsButton = ({ device, children }) => {
    const navigate = useNavigate();
    const { baseRoute, pathname } = useGetIDsFromURL();
    // Thing_ID and SerialNumber will be defined if clicking from SiteDetails DeviceTable
    // MASTER_SN will be defined if clicking from BatteryStacksTable
    // P_serialNumber will be defined if clicking from BatteryModulesTable
    const { Thing_ID, SerialNumber, MASTER_SN, P_serialNumber } = device;
    const generateDeviceRoute = () => {
        if (baseRoute === 'sites') {
            return `/devices/${Thing_ID}/${SerialNumber}/logs`;
        }
        return `${pathname}/${MASTER_SN ?? P_serialNumber}/logs`;
    };
    const deviceRoute = generateDeviceRoute();
    return (
        <Button
            variant="outline"
            className="bg-card hover:bg-muted dark:border-slate-800"
            onClick={(e) => {
                e.stopPropagation();
                navigate(deviceRoute);
            }}
        >
            {children}
        </Button>
    );
};
